import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import FormatTime from "../../AdsPage/FormatTime";
import { cardOutline, fonts, headingFonts } from "../../../Styles/Styles";
import LoadingAnimation from "../../Animations/LoadingAnimation";

export default function ContactFormEntriesManagement() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/contact/contact-form-entries`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch contact form entries");
        }
        const data = await response.json();
        setEntries(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEntries();
  }, []);

  if (loading) {
    return <LoadingAnimation />;
  }
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2, ...headingFonts }}>
        Contact Form Entries Management
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}

      {!loading && !error && (
        <TableContainer sx={{ ...cardOutline }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ ...headingFonts }}>Name</TableCell>
                <TableCell sx={{ ...headingFonts }}>Email</TableCell>
                <TableCell sx={{ ...headingFonts }}>Subject</TableCell>
                <TableCell sx={{ ...headingFonts }}>Message</TableCell>
                <TableCell sx={{ ...headingFonts }}>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.length > 0 ? (
                entries.map((entry) => (
                  <TableRow key={entry._id}>
                    <TableCell sx={{ ...headingFonts }}>{entry.name}</TableCell>
                    <TableCell sx={{ ...fonts }}>{entry.email}</TableCell>
                    <TableCell sx={{ ...fonts }}>{entry.subject}</TableCell>
                    <TableCell sx={{ ...fonts }}>{entry.message}</TableCell>
                    <TableCell sx={{ ...fonts }}>
                      <FormatTime createdAt={entry.createdAt} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ ...fonts }}>
                    No entries found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
